var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-wrap"},[_vm._l((_vm.items),function(item,index){return [(item.type === 'divider')?_c('div',{key:index,staticClass:"divider"}):_c('menu-item',_vm._b({key:index},'menu-item',item,false))]}),_c('input',{ref:"imageUpload",attrs:{"hidden":"","type":"file"},on:{"change":_vm.onFileSelected}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }